import React, { useEffect, useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DoneIcon from "@mui/icons-material/Done";
import { Cancel, CancelOutlined, Edit } from "@mui/icons-material";
import addpdforange from "../../assets/tasks/material-symbols-light_note-add-sharp.svg";
import CloseIcon from "@mui/icons-material/Close";
import Addnote from "../Modals/Addnote";
import dayjs from "dayjs";
import { orderTimeLabel } from "../../landingscreen/cards/visitflow";
import addpdf from "../../assets/tasks/addicon.svg";
import Updatenote from "../Modals/Updatenote";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import api from "../../api/api";
import careiqapi from "../../api/careiqapi";
import ScheduleModal from "../Modals/ScheduleModal";
import DoctorF from "../../assets/tasks/DoctorP.svg";
import Alertsgraphs from "../Modals/Alertsgraphs";

import { useSelector } from "react-redux";
import {
  cancelIcon,
  completedIcon,
  eyeIcon,
  fileIcon,
  flag,
  userIcon,
} from "../svgs";
import { COMPLETEDIcon, CROSSIcon } from "../../landingscreen/modals/svgs";
import ConfirmDialog from "../Modals/ConfirmDialog";
import { getPracticeId, patientPhotoUrl } from "../../config/practice";
import { SandboxedHtmlFrame, ccdaEmptyMessage, docPageKind, decodeUtf8B64 } from "../../landingscreen/patientcharts/tabs/careiq/sandboxedHtml";
import "./taskcard.css";
const FullViewCard = ({
  task,
  selectedIds,
  onToggleOrder,
  onTogglePatient,
  markAsFlag,
  markAsComplete,
  markAscancel,
  handleconfirmScheduleClick,
  scheduleStates,
  trigger,
  selectedOrder,
  setSelectedOrder,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [scheduleConfirmationOpen, setScheduleConfirmationOpen] =
    useState(false);
  // const [selectedOrder, setSelectedOrder] = useState(null);
  const [showAllOrders, setShowAllOrders] = useState(false);
  // const [isCompletedOrCancelled, setIsCompletedOrCancelled] = useState(false);
const practiseid = getPracticeId();
  const [completedOrders, setCompletedOrders] = useState({});
  // Inline document viewer for document-review tasks (order.result = "docref:docid:pid:doctype")
  // html: an HTML (or SVG) page (Athena documentdata / C-CDA render) shown in a sandboxed srcdoc
  // frame - never a blob: URL, which would run it in the care origin (review 10-07). Only a PDF
  // gets a blob: URL (typed application/pdf); img: a raster image; text: anything else, as plain
  // text (review 10-07n finding 3: "TEXT/HTML", SVG and XML pages went to the blob: URL).
  const EMPTY_DOC_VIEW = { open: false, loading: false, src: null, html: null, img: null, text: null, error: null };
  const [docView, setDocView] = useState(EMPTY_DOC_VIEW);
  const closeDocView = () => {
    if (docView.src && docView.src.startsWith("blob:")) URL.revokeObjectURL(docView.src);
    setDocView(EMPTY_DOC_VIEW);
  };
  const openDocFromTask = async (order) => {
    const ref = String(order?.result || "");
    if (!ref.startsWith("docref:")) return;
    const [, docid, pid] = ref.split(":");
    setDocView({ ...EMPTY_DOC_VIEW, open: true, loading: true });
    try {
      const res = await careiqapi.post(
        `/v1/fhir-mirror/${practiseid}/clinical-documents-by-id`,
        { patient_id: String(pid || order.patientid), clinicaldocument_id: String(docid) },
      );
      // careiqapi's interceptor already returns the body:
      // {status, data: [{pages: [...]}]} — so res.data IS the doc array.
      const entry = res?.data?.[0] || res?.data?.data?.[0];
      const page = entry?.pages?.[0];
      const shown = { ...EMPTY_DOC_VIEW, open: true };
      if (page?.data) {
        const raw = page.data.includes(",") ? page.data.split(",")[1] : page.data;
        const { kind, mime } = docPageKind(page.content_type, raw);
        if (kind === "html") {
          setDocView({ ...shown, html: { data: raw, kind: page.render === "ccda" ? "ccda" : "html" } });
        } else if (kind === "pdf") {
          // Chrome refuses data: PDFs inside iframes (renders blank) — convert
          // to a Blob URL like the chart viewer does (QA 2026-08-21).
          const byteString = atob(raw);
          const bytes = new Uint8Array(byteString.length);
          for (let i = 0; i < byteString.length; i += 1) bytes[i] = byteString.charCodeAt(i);
          const url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
          setDocView({ ...shown, src: url });
        } else if (kind === "image") {
          setDocView({ ...shown, img: `data:${mime};base64,${raw}` });
        } else {
          setDocView({ ...shown, text: decodeUtf8B64(raw).slice(0, 200000) });
        }
      } else {
        const msg = entry?.no_content_subclass === "CLINICALDOCUMENT_CCDA"
          ? ccdaEmptyMessage(entry?.no_content_reason)
          : "Document has no viewable pages.";
        setDocView({ ...shown, error: msg });
      }
    } catch (e) {
      setDocView({ ...EMPTY_DOC_VIEW, open: true, error: "Failed to load document." });
    }
  };
  const userConfig = useSelector((state) => state.userconfig);
  const [isAlertModal, setIsAlertModal] = useState(false);
  const [flagOption, setFlagOption] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const taskscreenprev = useSelector((state) => state.userPrivileges.taskrpm);
  const [confirmState, setConfirmState] = useState({
    open: false,
    type: null, // "complete" | "cancel"
    order: null,
  });

  const handleCompleteClick = (order) => {
    // open confirm dialog instead of acting immediately
    setConfirmState({ open: true, type: "complete", order });
  };

  const handleCancelClick = (order) => {
    // open confirm dialog instead of acting immediately
    setConfirmState({ open: true, type: "cancel", order });
  };

  const handleAlertOpenModal = (order) => {
    setSelectedAlert(order); // Store the selected patient ID
    setIsAlertModal(true); // Open the modal
  };
  const handleAlertCloseModal = () => {
    setIsAlertModal(false); // Close the modal
  };
  const updateResult = async (order, value) => {
  try {
    // optimistic update
    order.result = value;

    await api.put(`/v1/${practiseid}/orders/${task.patientid}/update-result`, {
      id: order.id,
      result: value,
      orderdate: dayjs(order.ts).format("YYYY-MM-DD"),
    });

    trigger(); // refresh parent list
  } catch (e) {
    console.log("result update failed", e);
  }
};
  // Function to open the modal
  const openModal = (order) => {
    setSelectedOrder(order); // Set the selected order dynamically
    if (order.order_notes) {
      setModalType("update");
    } else {
      setModalType("add");
    }
    setIsModalOpen(true);
  };
  let user = localStorage.getItem("user");

  const runConfirmAction = () => {
    const { type, order } = confirmState;
    if (!order) return;

    if (type === "complete") {
      markAsComplete([order.id.toString()], order);
      setCompletedOrders((prev) => ({ ...prev, [order.id]: "completed" }));
    } else if (type === "cancel") {
      markAscancel([order.id.toString()], order);
      setCompletedOrders((prev) => ({ ...prev, [order.id]: "cancelled" }));
    }

    setConfirmState({ open: false, type: null, order: null });
  };

  const closeConfirm = () =>
    setConfirmState({ open: false, type: null, order: null });

  // const handleCompleteClick = (order) => {
  //   markAsComplete([order.id.toString()], order);
  //   // setIsCompletedOrCancelled(order); // Step 2: Update the state when a button is clicked
  //   setCompletedOrders((prevState) => ({
  //     ...prevState,
  //     [order.id]: "completed",
  //   }));
  // };

  // const handleCancelClick = (order) => {
  //   markAscancel([order.id.toString()], order);
  //   // setIsCompletedOrCancelled(order); // Step 2: Update the state when a button is clicked
  //   setCompletedOrders((prevState) => ({
  //     ...prevState,
  //     [order.id]: "cancelled",
  //   }));
  // };

  const handleScheduleClick = (order) => {
    setSelectedOrder(order); // Set the selected order for confirmation
    setScheduleConfirmationOpen(order); // Open the confirmation modal
  };

  // Function to close the modal
  const closeModal = () => setIsModalOpen(false);

  const closeScheduleConfirmationModal = () => {
    setScheduleConfirmationOpen(false);
    setSelectedOrder(null);
  };

  const percentage = 100; // Set your percentage value here

  // Styles for the circular progress bar and small circle with percentage text
  const circleStyle = {
    background: `conic-gradient(#E17954B2 ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };

  const angle = percentage * 3.6;
  const getOrderStatusColor = (status) => {
    switch (status) {
      case "CANCELLED":
        return "bg-red-500";
      case "INFO":
        return "bg-blue-500";
      case "CREATED":
        return "bg-[#E17954]";
      case "COMPLETED":
        return "bg-green-500";
      default:
        return "bg-red-500";
    }
  };

  const toggleShowAllOrders = () => {
    setShowAllOrders((prev) => !prev); // Toggle show/hide all orders
  };
  const normalise = (type) => {
    return type === "procedure" ? "procedures" : type;
  };
  const visibleOrders = task.orders.filter((order) => {
    const type = order.ordertype.toLowerCase();
    return !(
      (type === "labs" || type === "schedule-rto" || type === "procedure") &&
      !taskscreenprev.some((item) => item.toLowerCase() === normalise(type))
    );
  });

  const totalCount = visibleOrders.length;
  const createdCount = visibleOrders.filter(
    (o) => String(o?.status).toUpperCase() === "CREATED"
  ).length;
  const allCompleted =
    totalCount > 0 &&
    visibleOrders.every((o) => String(o?.status).toUpperCase() === "COMPLETED");

  // what to show in the pill
  const pillCount = allCompleted ? totalCount : createdCount;
  // pill color: grey when all done, orange when still have "CREATED"
  const pillBg = allCompleted ? "bg-[#99A1AF]" : "bg-[#E17954]";

  // --- selection + display helpers -------------------------------------------
  const isClosedStatus = (o) =>
    ["COMPLETED", "CANCELLEDTASK"].includes(String(o?.status).toUpperCase());
  const selectable = visibleOrders.filter((o) => !isClosedStatus(o));
  const pickedHere = selectable.filter((o) => selectedIds?.has(String(o.id)));
  const headState =
    pickedHere.length === 0 ? "" : pickedHere.length === selectable.length ? "on" : "some";
  const shownOrders = visibleOrders.slice(0, showAllOrders ? visibleOrders.length : 2);
  const catOf = (type) => {
    const t = String(type || "").toLowerCase();
    if (t.startsWith("inject")) return "injections";
    if (t.startsWith("schedule")) return "schedule";
    if (t.startsWith("refill") || t.startsWith("prescription")) return "refills";
    if (t.startsWith("lab")) return "labs";
    if (t.startsWith("procedure")) return "procedures";
    if (t.startsWith("referral")) return "referrals";
    if (t.startsWith("alert")) return "alerts";
    if (t.startsWith("note")) return "notes";
    if (t.startsWith("diagnos") || t.startsWith("imaging")) return "imaging";
    return "other";
  };
  const dob = task.dob && dayjs(task.dob).isValid() ? dayjs(task.dob).format("MM-DD-YYYY") : null;
  const Check = () => (
    <svg fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
  const Dash = () => (
    <svg fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 12h12" />
    </svg>
  );
  const FlagGlyph = ({ filled }) => (
    <svg viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M5 21V4m0 0h11l-2 4 2 4H5" strokeLinejoin="round" />
    </svg>
  );
  const EyeGlyph = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
      <circle cx="12" cy="12" r="2.8" />
    </svg>
  );
  const NoteGlyph = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M14 3.5H7A1.5 1.5 0 0 0 5.5 5v14A1.5 1.5 0 0 0 7 20.5h10a1.5 1.5 0 0 0 1.5-1.5V8L14 3.5Z" />
      <path d="M14 3.5V8h4.5M12 11v6M9 14h6" />
    </svg>
  );
  const Chevron = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
  const prettyName = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "");

  return (
    <div key={task.id} className="bmtk">
      <div className="bmtk-head">
        <button
          type="button"
          className={`bmtk-check${headState ? ` ${headState}` : ""}`}
          aria-label={headState === "on" ? "Deselect this patient's tasks" : "Select this patient's open tasks"}
          aria-checked={headState === "on" ? "true" : headState === "some" ? "mixed" : "false"}
          role="checkbox"
          disabled={!selectable.length}
          onClick={() => onTogglePatient?.(selectable, headState !== "on")}
        >
          {headState === "on" ? <Check /> : headState === "some" ? <Dash /> : null}
        </button>
        {/* The ring keeps the coverage colour (deductiblemet) the photo frame had. */}
        <img
          src={patientPhotoUrl(task.patientid)}
          alt=""
          className="bmtk-photo"
          style={task.deductiblemet ? { "--ring": `#${task.deductiblemet}` } : undefined}
          onError={(e) => {
            // no photo: keep the grey frame rather than a broken-image icon
            e.currentTarget.onerror = null;
            e.currentTarget.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
          }}
        />
        <div className="bmtk-who">
          <div className="bmtk-name">{task.patient_name}</div>
          <div className="bmtk-meta">
            {[`#${task.patientid}`, dob && `DOB ${dob}`, (task.insurancename || "No insurance name").toUpperCase()]
              .filter(Boolean)
              .join(" · ")}
          </div>
        </div>
        <div className="bmtk-open">
          <span className={`bmtk-open-n${allCompleted ? " done" : ""}`}>{pillCount}</span>
          {allCompleted ? "done" : "open"}
        </div>
      </div>

      <div className="bmtk-rows">
        {shownOrders.map((order, index) => {
          const status = String(order?.status).toUpperCase();
          const closed = isClosedStatus(order);
          const picked = selectedIds?.has(String(order.id));
          const showDoneBy = order.status !== "CREATED" && task?.status !== "FLAGGED" && order?.completed_by;
          const scheduled = scheduleStates[order.id] || order?.schedule === "t";
          const canEditSchedule = order.status !== "COMPLETED" && order.ordertype !== "Notes" && order.status !== "CANCELLEDTASK";
          const hasEye = order.ordertype === "Alerts" || String(order?.result || "").startsWith("docref:");
          return (
            <div
              key={order.id ?? index}
              className={`bmtk-row cat-${catOf(order.ordertype)}${picked ? " selected" : ""}${closed ? " closed" : ""}`}
            >
              <button
                type="button"
                role="checkbox"
                aria-checked={picked ? "true" : "false"}
                aria-label={`Select ${order.ordername || order.ordertype}`}
                className={`bmtk-check${picked ? " on" : ""}`}
                disabled={closed}
                onClick={() => onToggleOrder?.(order)}
              >
                {picked ? <Check /> : null}
              </button>

              <div className="bmtk-main">
                <div className="bmtk-tags">
                  <span className="bmtk-type">{order.ordertype}</span>
                  {!order?.order_notes && order.ordertype !== "Notes" && (
                    <button
                      type="button"
                      className={`bmtk-when${scheduled ? " scheduled" : ""}`}
                      disabled={!canEditSchedule}
                      title={canEditSchedule ? "Change when this is done" : undefined}
                      onClick={() => {
                        if (canEditSchedule) handleScheduleClick(order);
                      }}
                    >
                      {canEditSchedule && <Edit />}
                      {scheduled ? "Schedule" : "Today"}
                    </button>
                  )}
                  {status === "FLAGGED" && (
                    <span className="bmtk-flagged">
                      <FlagGlyph filled />
                      Flagged
                    </span>
                  )}
                </div>
                <div className="bmtk-title">
                  {order.ordername && order.ordername.trim() !== ""
                    ? order.ordername.replace(/<[^>]*>/g, "")
                    : `${order.tov} Level - ${order.lov}`}
                </div>
                {["FLU TEST", "STREP TEST", "COVID TEST"].includes(
                  order?.ordername?.toUpperCase().replace(/[-_]/g, " ").trim()
                ) && (
                  <select
                    className="bmtk-result"
                    value={order.result || ""}
                    disabled={closed}
                    onChange={(e) => updateResult(order, e.target.value)}
                  >
                    <option value="">Select Result</option>
                    <option value="Positive">Positive</option>
                    <option value="Negative">Negative</option>
                    <option value="Inconclusive">Inconclusive</option>
                  </select>
                )}
                {order?.order_notes && (
                  <div className="bmtk-note">
                    {order.order_notes}
                    {order?.completed_by && <span className="bmtk-note-by">{prettyName(order.completed_by)}</span>}
                  </div>
                )}
              </div>

              <div className="bmtk-by">
                <div className="bmtk-by-k">Ordered by</div>
                <div className="bmtk-by-v">{order?.provider_name || order?.provider || "-"}</div>
                <div className="bmtk-by-t">{orderTimeLabel(order)}</div>
              </div>

              <div className="bmtk-actions">
                {showDoneBy ? (
                  <span className={`bmtk-doneby${status === "COMPLETED" ? " ok" : status === "CANCELLEDTASK" ? " off" : ""}`}>
                    {status === "COMPLETED" ? "✓ Completed" : status === "CANCELLEDTASK" ? "Cancelled" : userIcon}
                    {" · "}
                    {prettyName(order.completed_by)}
                  </span>
                ) : (
                  <>
                    {taskscreenprev.includes("Mark Completed") && (
                      <button type="button" className="bmtk-complete" onClick={() => handleCompleteClick(order)}>
                        <Check />
                        Complete
                      </button>
                    )}
                    {taskscreenprev.includes("Cancel Task") && (
                      <button type="button" className="bmtk-cancel" onClick={() => handleCancelClick(order)}>
                        Cancel
                      </button>
                    )}
                  </>
                )}
                <span className="bmtk-sep" />
                <button
                  type="button"
                  className={`bmtk-icon${status === "FLAGGED" ? " flag-on" : ""}${closed ? " idle" : ""}`}
                  title={status === "FLAGGED" ? "Unflag" : "Flag"}
                  aria-label={status === "FLAGGED" ? "Unflag" : "Flag"}
                  disabled={closed}
                  onClick={() => markAsFlag([order.id.toString()], order, order.status)}
                >
                  <FlagGlyph filled={status === "FLAGGED"} />
                </button>
                <button
                  type="button"
                  className={`bmtk-icon${hasEye ? "" : " idle"}`}
                  title={order.ordertype === "Alerts" ? "View readings" : "View document"}
                  aria-label={order.ordertype === "Alerts" ? "View readings" : "View document"}
                  disabled={!hasEye}
                  onClick={() => {
                    if (order.ordertype === "Alerts") handleAlertOpenModal(order.patientid);
                    else openDocFromTask(order);
                  }}
                >
                  <EyeGlyph />
                </button>
                <button
                  type="button"
                  className={`bmtk-icon${closed ? " idle" : ""}`}
                  title={order.order_notes ? "Edit note" : "Add note"}
                  aria-label={order.order_notes ? "Edit note" : "Add note"}
                  disabled={closed}
                  onClick={() => openModal(order)}
                >
                  <NoteGlyph />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {visibleOrders.length > 2 && (
        <button type="button" className={`bmtk-more${showAllOrders ? " open" : ""}`} onClick={toggleShowAllOrders}>
          {showAllOrders ? "Show less" : "View all"}
          <span className="bmtk-more-n">{visibleOrders.length}</span>
          <Chevron />
        </button>
      )}

      {docView.open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4"
             onClick={closeDocView}>
          <div className="bg-white rounded-xl shadow-xl w-[90%] max-w-4xl h-[85vh] flex flex-col"
               onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between border-b px-4 py-3">
              <div className="text-sm font-semibold text-[#1D2951]">Document</div>
              <button className="text-gray-400 hover:text-gray-600"
                      onClick={closeDocView}>
                <CloseIcon />
              </button>
            </div>
            <div className="flex-1 overflow-hidden">
              {docView.loading ? (
                <div className="h-full flex items-center justify-center text-sm text-gray-500">Loading document…</div>
              ) : docView.error ? (
                <div className="h-full flex items-center justify-center text-sm text-red-500 px-6 text-center">{docView.error}</div>
              ) : docView.html ? (
                <SandboxedHtmlFrame data={docView.html.data} kind={docView.html.kind} fill title="Document" />
              ) : docView.src ? (
                <iframe title="Document" src={docView.src} className="w-full h-full rounded-b-xl border-0" />
              ) : docView.img ? (
                <div className="w-full h-full overflow-auto flex justify-center bg-white rounded-b-xl">
                  <img src={docView.img} alt="Document" className="max-w-full h-auto" />
                </div>
              ) : docView.text !== null ? (
                <pre data-testid="doc-text" className="w-full h-full overflow-auto whitespace-pre-wrap break-words text-xs p-4 bg-white rounded-b-xl">{docView.text}</pre>
              ) : null}
            </div>
          </div>
        </div>
      )}
      {isModalOpen &&
        (modalType === "add" ? (
          <Addnote
            trigger={trigger}
            closeModal={closeModal}
            task={selectedOrder}
          />
        ) : (
          <Updatenote
            trigger={trigger}
            closeModal={closeModal}
            task={selectedOrder}
          />
        ))}
      <ScheduleModal
        open={scheduleConfirmationOpen}
        onClose={closeScheduleConfirmationModal}
        onConfirm={handleconfirmScheduleClick}
        order={selectedOrder}
      />
      {isAlertModal && (
        <Alertsgraphs
          PatientID={selectedAlert}
          isAlert={true}
          onClose={handleAlertCloseModal}
        />
      )}

      <ConfirmDialog
        open={confirmState.open}
        title={confirmState.type === "cancel" ? "Cancel Task" : "Complete Task"}
        description={
          confirmState.type === "cancel"
            ? "Are you sure you want to cancel this task?"
            : "Are you sure you want to mark this task as complete?"
        }
        cancelLabel="Keep Task"
        confirmLabel={
          confirmState.type === "cancel"
            ? "Yes, Cancel Task"
            : "Yes, Complete Task"
        }
        variant={confirmState.type === "cancel" ? "danger" : "success"}
        onConfirm={runConfirmAction}
        onClose={closeConfirm}
      />
    </div>
  );
};

export default FullViewCard;
